import React from "react";

import { AnimationOnScroll } from "react-animation-on-scroll";
import { Col, Container, Image, Row } from "react-bootstrap";

import i18n from "../../i18n";

const PakVertPanelsScreen: React.FC = () => {
  const { t, language } = i18n;

  return (
    <Container
      fluid
      className="screenContainer infoDarkContainer"
      style={{ minHeight: "50vh" }}
    >
      <Container className="flexContainer pakvertContainer">
        <Row className="gx-5">
          <Col lg={7} xs={12}>
            <div className="flexContainer" style={{ gap: "8px" }}>
              <h2>{t("_technology_screen.1.title")}</h2>
              <p>{t("_technology_screen.1.description")}</p>
            </div>
          </Col>

          <Col lg={5} xs={12}>
            <div className="flexContainer">
              <AnimationOnScroll
                animateOnce
                animateIn="animate__fadeInRightBig"
              >
                <Image
                  rounded
                  alt={t("_technology_screen.1.title")}
                  className="mw-100"
                  src={`/images/technology/PakVert_Panel_Layers_${language}.png`}
                />
              </AnimationOnScroll>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default PakVertPanelsScreen;
